const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankDetails = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.742188 4.679688 L 10.484375 1.421875 C 10.144531 1.082031 9.589844 1.082031 9.25 1.421875 L 5.335938 5.335938 C 5.222656 5.449219 5.222656 5.632812 5.335938 5.75 C 5.449219 5.863281 5.632812 5.863281 5.746094 5.75 L 9.660156 1.835938 C 9.773438 1.722656 9.960938 1.722656 10.074219 1.835938 L 13.332031 5.09375 C 13.445312 5.207031 13.445312 5.390625 13.332031 5.507812 L 10 8.835938 C 9.886719 8.949219 9.886719 9.136719 10 9.25 C 10.058594 9.304688 10.132812 9.332031 10.207031 9.332031 C 10.28125 9.332031 10.355469 9.304688 10.414062 9.246094 L 13.742188 5.917969 C 14.085938 5.578125 14.085938 5.023438 13.742188 4.679688 Z M 13.742188 4.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.996094 2.421875 C 10.882812 2.304688 10.699219 2.304688 10.585938 2.421875 L 7.667969 5.335938 C 7.554688 5.449219 7.554688 5.636719 7.667969 5.75 C 7.726562 5.804688 7.800781 5.832031 7.875 5.832031 C 7.949219 5.832031 8.023438 5.804688 8.082031 5.75 L 10.996094 2.832031 C 11.109375 2.71875 11.109375 2.535156 10.996094 2.421875 Z M 10.996094 2.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.042969 5.25 L 0.875 5.25 C 0.714844 5.25 0.582031 5.121094 0.582031 4.957031 C 0.582031 4.796875 0.714844 4.667969 0.875 4.667969 L 6.707031 4.667969 C 6.867188 4.667969 7 4.535156 7 4.375 C 7 4.214844 6.867188 4.085938 6.707031 4.085938 L 0.875 4.085938 C 0.390625 4.085938 0 4.476562 0 4.957031 L 0 11.957031 C 0 12.441406 0.390625 12.832031 0.875 12.832031 L 9.042969 12.832031 C 9.84375 12.832031 10.5 12.179688 10.5 11.375 L 10.5 6.707031 C 10.5 5.90625 9.84375 5.25 9.042969 5.25 Z M 9.914062 11.375 C 9.914062 11.859375 9.523438 12.25 9.042969 12.25 L 0.875 12.25 C 0.714844 12.25 0.582031 12.121094 0.582031 11.957031 L 0.582031 5.785156 C 0.675781 5.816406 0.773438 5.832031 0.875 5.832031 L 9.042969 5.832031 C 9.523438 5.832031 9.914062 6.226562 9.914062 6.707031 Z M 9.914062 11.375 "
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bank-details.767674693f9ad491a4432195380070a9.svg";